export const id = state => state.id
export const nom = state => state.nom
export const code = state => state.code
export const contactTel1 = state => state.contactTel1
export const contactTel2 = state => state.contactTel2
export const contactNom = state => state.contactNom
export const contactEmail = state => state.contactEmail
export const adresse = state => state.adresse
export const complementAdresse = state => state.complementAdresse
export const codePostal = state => state.codePostal
export const ville = state => state.ville
export const departement = state => state.departement
export const societe = state => state.societe
export const typeOperations = state => state.typeOperations
export const typeErp = state => state.typeErp
export const client = state => state.client
export const etat = state => state.etat
export const listProjets = state => state.listProjets
export const numeroAffaire = state => state.numeroAffaire



// WEBPACK FOOTER //
// ./src/store/modules/projectForm/getters.js